import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import styles from '../shared/styles';
import ImageArt from './imageart';
import Colors from '../../../../styles/colors';
import { RowDivision, DivisionLabel } from '../shared/styled-components';

class Hosts extends Component {
  constructor(props) {
    super(props);

    this.onInputChange = this.onInputChange.bind(this);
  }

  onInputChange(statekey) {
    return (e) => {
      const value = e.target.value;
      this.props.onChange(statekey, value);
    };
  }

  render() {
    const {
      soundcastId,
      hostTitle = '',
      list,
      onAdd,
      onRemove,
      onChange,
      withCrop,
      cropperHandler,
      persistUploaderOnSuccess,
      autoSave,
    } = this.props;

    return (
      <RowDivision className="row">
        <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12">
          <DivisionLabel>
           Host / Instructor Section
          </DivisionLabel>
          <div style={styles.hostInfoWrapper}>
            <div style={styles.hostInfoInputDivision}>
              <div style={{ ...styles.inputLabelWrapper, fontWeight: 500 }}>
                Section Title
              </div>
              <input
                type="text"
                style={styles.inputTitle}
                placeholder={'YOUR GUIDE'}
                onChange={this.onInputChange('hostTitle')}
                value={hostTitle}
              />
            </div>
            {list.map((instructor, index) => {
              // produce hostName, hostName1
              // just to stay with the current state setup
              const suffixIndex = (index > 0) ? index + 1 : index;
              const hostNameKey = (index > 0) ? `hostName${suffixIndex}` : 'hostName';
              const hostBioKey = (index > 0) ? `hostBio${suffixIndex}` : 'hostBio';
              const hostImageURLKey = (index > 0) ? `hostImageURL${suffixIndex}` : 'hostImageURL';
              const hostImageRenameKey = (index > 0) ? `host${suffixIndex}-image` : 'host-image';

              const placeholderImg = 'https://soundwiseinc.s3.amazonaws.com/user_profile_pic_placeholder.png';
              const imageUrl = (isEmpty(instructor.hostImageURL)) ? placeholderImg : instructor.hostImageURL;

              return (
                <div key={`hostinfo-${index}`}>
                  <div style={styles.hostInfoInputDivision}>
                    <ImageArt
                      soundcastId={soundcastId}
                      datakey={hostImageURLKey}
                      value={imageUrl}
                      filename={hostImageRenameKey}
                      withBlur={false}
                      required={false}
                      uploader={{
                        header: (
                          <React.Fragment>
                            Host profile picture&nbsp;
                            <span style={styles.miniSubheaderText}>
                              Only .jpg or .png files are accepted
                            </span>
                          </React.Fragment>
                        ),
                        style: {
                          padding: 0,
                        },
                        options: {
                          allowImageValidateSize: false,
                        }
                      }}
                      withCrop={withCrop}
                      cropperHandler={cropperHandler}
                      persistUploaderOnSuccess={persistUploaderOnSuccess}
                      autoSave={autoSave}
                      onChange={onChange}
                      artStyle={{
                        cover: { position: 'relative', display: 'inline-block' },
                        image: {
                          ...styles.hostImage,
                          borderRadius: '50%',
                        },
                        button: {
                          ...styles.uploadResourceButton,
                          width: 100,
                          height: 50,
                          borderBottomRightRadius: 50,
                          borderBottomLeftRadius: 50,
                          fontSize: '1.5rem',
                        },
                      }}
                    />
                  </div>
                  <div style={styles.hostInfoInputDivision}>
                    <div style={{ ...styles.inputLabelWrapper, fontWeight: 500 }}>
                      Name
                    </div>
                    <input
                      type="text"
                      style={styles.inputTitle}
                      placeholder={''}
                      onChange={this.onInputChange(hostNameKey)}
                      value={instructor.hostName || ''}
                    />
                  </div>
                  <div style={styles.hostInfoInputDivision}>
                    <div style={{ ...styles.inputLabelWrapper, fontWeight: 500 }}>
                      Bio
                    </div>
                    <textarea
                      style={{ ...styles.inputTitle, height: 100, minHeight: 100, maxHeight: 250, resize: 'vertical' }}
                      placeholder="Who will be teaching?"
                      onChange={this.onInputChange(hostBioKey)}
                      value={instructor.hostBio || ''}
                    />
                  </div>
                  {(list.length > 1) && (
                    <div style={styles.hostInfoDivider}>Host #{(index + 1)}</div>
                  )}
                </div>
              );
            })}

            {(list.length === 1) && (
              <button
                style={{
                  ...styles.addFeatureButton,
                  ...styles.hostAddButton,
                  backgroundColor: Colors.mainOrange
                }}
                onClick={onAdd}>
                Add second Host/Instructor
              </button>
            )}

            {(list.length > 1) && (
              <button
                style={{
                  ...styles.addFeatureButton,
                  ...styles.hostAddButton,
                  backgroundColor: '#F44336'
                }}
                onClick={onRemove}>
                Remove second Host/Instructor
              </button>
            )}
          </div>
        </div>
      </RowDivision>
    );
  }
}

Hosts.propTypes = {
  list: PropTypes.array,
  onAdd: PropTypes.func,
  onRemove: PropTypes.func,
  onChange: PropTypes.func,
  withCrop: PropTypes.bool,
  cropperHandler: PropTypes.func,
  persistUploaderOnSuccess: PropTypes.bool,
  autoSave: PropTypes.bool,
};

Hosts.defaultProps = {
  list: [],
  onAdd: () => {},
  onRemove: () => {},
  onChange: () => {},
  withCrop: true,
  cropperHandler: () => {},
  persistUploaderOnSuccess: false,
  autoSave: false,
};

export default Hosts;
